module.exports = new __parcel__URL__("this-is-new-jira.80f28371.png").toString();